import React from "react";
import { Message } from "components/Atoms/Message";
import { Button } from "semantic-ui-react";
import { TermsAndConditions } from "./TermsAndConditions";

interface Props {
  session: server.dto.ClientOnboardingSession
  onFinished: (newSession: server.dto.ClientOnboardingSession) => void
}

const TrialSubscription = (props: Props) => {
  const [termsHasError, setTermsHasError] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [serverErrors, setServerErrors] = React.useState<string[]>([]);
  const [hasAgreedWithTerms, setHasAgreedWithTerms] = React.useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();

    setTermsHasError(!hasAgreedWithTerms);

    if (!hasAgreedWithTerms) {
      return;
    }

    setIsSubmitting(true);

    try {
      const res = await window.CoreApi.ClientOnboardingOpen.SetLifecycle({
        secret: props.session.secret,
        lifeCycle: "readyForCreateClientAccount"
      });

      if (res.data.errors.length > 0) {
        setServerErrors(res.data.errors.map(e => e.message));
        return;
      }

      const newSession = await window.CoreApi.ClientOnboardingOpen.GetOnboardingSession(props.session.secret);
      props.onFinished(newSession.data.data);
    } catch {
      setServerErrors([RESX.GeneralLabels.SomethingUnexpectedHappened]);
    } finally {
      setIsSubmitting(false);
    }
  };

  return <form onSubmit={onSubmit} style={{ display: "inline" }}>

    <div className="flex margin-bottom-huge justify-space-between">
      <div className="padding-big flex-column blue-bg white-text" style={{ flex: "0 0 48%" }}>
        <div className="grow1">
          <div className="flex margin-bottom-huge">
            <div className="grow1">
              <h2>Trial</h2>
            </div>
          </div>
          <div className="grow1 margin-bottom-huge">
            <div className="flex margin-bottom">
              <div className="grow1 big_text">14 days trial</div>
            </div>
            <div className="flex margin-bottom">
              <div className="grow1 big_text">Personal get-started introduction</div>
            </div>
          </div>
          <div className="flex justify-end">
            <div className="big_text nowrap">Free</div>
          </div>
        </div>
      </div>
    </div>

    <TermsAndConditions
      hasAgreedWithTerms={hasAgreedWithTerms}
      setHasAgreedWithTerms={setHasAgreedWithTerms}
      hasError={termsHasError}
      setHasError={setTermsHasError}
    />

    <div className="flex margin-top">
      <div className="grow1 margin-right">
        {serverErrors.length > 0 && <Message type="error">
          {serverErrors.map((error) => <div key={error}>{error}</div>)}
        </Message>}
      </div>
      <div>
        <Button
          primary
          type="submit"
          onClick={onSubmit}
          loading={isSubmitting}
          disabled={isSubmitting}
        >
          {RESX.Buttons.btnNextStep}
        </Button>
      </div>
    </div>
  </form>
};

export default TrialSubscription;